import { IsUUID, IsNotEmpty, IsOptional } from 'class-validator';

export class DownloadTemplateDto {
  @IsUUID()
  @IsNotEmpty()
  templateId: string;

  @IsUUID()
  @IsOptional()
  fileId?: string;
}
